import React from 'react'
import _ from 'lodash'
import { PoseGroup } from 'react-pose'
import PropTypes from 'prop-types'
import Collapse from '@kunukn/react-collapse'
import { Col, Row } from 'react-styled-flexboxgrid'
import * as styles from './styles'
import { Section } from '..'

const propTypes = {
  header: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  images: PropTypes.array.isRequired
}

export default class CollapsibleList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      index: 0
    }
  }

  onToggle = (index) => {
    this.setState(state => ({ index: state.index === index ? state.index : index }))
  }

  render() {
    const { items, header, images } = this.props
    const { index } = this.state

    function createContent(text) {
      return (
        <styles.ItemText>
          {text}
        </styles.ItemText>
      )
    }

    return (
      <styles.Container>
        <styles.SubContainer>
          <Row>
            <Col xs={12}>
              <styles.BlockHeader>
                {header}
              </styles.BlockHeader>
            </Col>
          </Row>
          <Section>
            <Row>
              <styles.ImageCol sm={6} xs={12}>
                <styles.ImageContainer>
                  <PoseGroup>
                    <styles.DisplayImage key={index} src={images[index]} />
                  </PoseGroup>
                </styles.ImageContainer>
              </styles.ImageCol>
              <Col sm={6} xs={12}>
                {_.map(items, (item, i) => {
                  const isItemActive = i === index
                  return (
                    <styles.ItemContainer key={i} isOpen={isItemActive}>
                      <styles.ItemHeader
                        onClick={() => this.onToggle(i)}
                      >
                        {item.header}
                      </styles.ItemHeader>
                      <Collapse
                        isOpen={index === i}
                        render={() => createContent(item.text)}
                      />
                    </styles.ItemContainer>
                  )
                })}
              </Col>
            </Row>
          </Section>
        </styles.SubContainer>
      </styles.Container>
    )
  }
}

CollapsibleList.propTypes = propTypes
